export const HottubIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.0658 21.452H4.31851C3.70001 21.452 3.1969 20.9489 3.1969 20.3304V10.7769C3.1969 10.6451 3.30392 10.5381 3.43576 10.5381H16.4479C16.5798 10.5381 16.6868 10.6451 16.6868 10.7769V12.8505H19.0864V10.7769C19.0864 10.6451 19.1936 10.5381 19.3253 10.5381H20.9459C21.0778 10.5381 21.1848 10.6451 21.1848 10.7769V20.3325C21.1852 20.9495 20.6828 21.452 20.0658 21.452ZM3.67466 11.0158V20.3304C3.67466 20.6855 3.96341 20.9741 4.31855 20.9741L20.0658 20.9741C20.4196 20.9741 20.7074 20.6863 20.7074 20.3325V11.0158H19.5644V13.0895C19.5644 13.2213 19.4572 13.3283 19.3255 13.3283H16.448C16.3162 13.3283 16.2091 13.2212 16.2091 13.0895V11.0158L3.67466 11.0158Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.7091 11.0158H19.3254C19.1935 11.0158 19.0865 10.9088 19.0865 10.7769V8.91354C19.0865 8.7817 19.1937 8.67468 19.3254 8.67468H21.7091C21.841 8.67468 21.948 8.7817 21.948 8.91354V10.7768C21.948 10.9088 21.841 11.0158 21.7091 11.0158ZM19.5643 10.5381H21.4701V9.1524H19.5643V10.5381ZM16.4479 11.0158H2.67277C2.54093 11.0158 2.43396 10.9088 2.43396 10.7769V8.91354C2.43396 8.7817 2.54093 8.67468 2.67277 8.67468H16.4479C16.5797 8.67468 16.6867 8.7817 16.6867 8.91354V10.7768C16.6867 10.9088 16.5797 11.0158 16.4479 11.0158ZM2.91163 10.5381H16.209V9.1524H2.91163V10.5381Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.946 17.5472H3.43576C3.30392 17.5472 3.1969 17.44 3.1969 17.3083V14.6817C3.1969 14.5499 3.30392 14.4429 3.43576 14.4429H20.946C21.0779 14.4429 21.1849 14.55 21.1849 14.6817V17.3083C21.1851 17.44 21.0779 17.5472 20.946 17.5472ZM3.67462 17.0693H20.7072V14.9206H3.67462V17.0693Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.49533 21.4521C6.36349 21.4521 6.25647 21.3449 6.25647 21.2132V17.3083C6.25647 17.1764 6.36349 17.0694 6.49533 17.0694C6.62717 17.0694 6.73419 17.1766 6.73419 17.3083V21.2132C6.73419 21.3449 6.62736 21.4521 6.49533 21.4521ZM6.49533 14.9206C6.36349 14.9206 6.25647 14.8134 6.25647 14.6817V10.7769C6.25647 10.6451 6.36349 10.5381 6.49533 10.5381C6.62717 10.5381 6.73419 10.6451 6.73419 10.7769V14.6817C6.73419 14.8134 6.62736 14.9206 6.49533 14.9206Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.34317 21.4521C9.21133 21.4521 9.10431 21.3449 9.10431 21.2132V17.3083C9.10431 17.1764 9.21133 17.0694 9.34317 17.0694C9.47497 17.0694 9.58198 17.1766 9.58198 17.3083V21.2132C9.58198 21.3449 9.47497 21.4521 9.34317 21.4521ZM9.34317 14.9206C9.21133 14.9206 9.10431 14.8134 9.10431 14.6817V10.7769C9.10431 10.6451 9.21133 10.5381 9.34317 10.5381C9.47497 10.5381 9.58198 10.6451 9.58198 10.7769V14.6817C9.58198 14.8134 9.47497 14.9206 9.34317 14.9206Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.191 21.4521C12.0592 21.4521 11.9521 21.3449 11.9521 21.2132V17.3083C11.9521 17.1764 12.0592 17.0694 12.191 17.0694C12.3229 17.0694 12.4299 17.1766 12.4299 17.3083V21.2132C12.4299 21.3449 12.3229 21.4521 12.191 21.4521ZM12.191 14.9206C12.0592 14.9206 11.9521 14.8134 11.9521 14.6817V10.7769C11.9521 10.6451 12.0592 10.5381 12.191 10.5381C12.3229 10.5381 12.4299 10.6451 12.4299 10.7769V14.6817C12.4299 14.8134 12.3229 14.9206 12.191 14.9206Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0388 21.4521C14.9069 21.4521 14.7999 21.3449 14.7999 21.2132V17.3083C14.7999 17.1764 14.9071 17.0694 15.0388 17.0694C15.1705 17.0694 15.2776 17.1766 15.2776 17.3083V21.2132C15.2776 21.3449 15.1707 21.4521 15.0388 21.4521ZM15.0388 14.9206C14.9069 14.9206 14.7999 14.8134 14.7999 14.6817V10.7769C14.7999 10.6451 14.9071 10.5381 15.0388 10.5381C15.1705 10.5381 15.2776 10.6451 15.2776 10.7769V14.6817C15.2776 14.8134 15.1707 14.9206 15.0388 14.9206Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8867 21.4522C17.7548 21.4522 17.6478 21.345 17.6478 21.2133V17.3084C17.6478 17.1766 17.755 17.0695 17.8867 17.0695C18.0184 17.0695 18.1255 17.1767 18.1255 17.3084V21.2133C18.1255 21.345 18.0185 21.4522 17.8867 21.4522ZM17.8867 14.9207C17.7548 14.9207 17.6478 14.8135 17.6478 14.6818V13.0896C17.6478 12.9578 17.755 12.8508 17.8867 12.8508C18.0184 12.8508 18.1255 12.9579 18.1255 13.0896V14.6818C18.1255 14.8135 18.0185 14.9207 17.8867 14.9207Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.0919 9.15249C21.0912 9.15249 21.0932 9.15268 21.0919 9.15249H3.29318C3.16134 9.15249 3.05432 9.04547 3.05432 8.91363C3.05432 7.61687 4.10926 6.56189 5.40588 6.56189C5.89287 6.56189 6.36772 6.71386 6.76287 6.99287C7.15784 6.71367 7.63283 6.56189 8.11986 6.56189C8.60685 6.56189 9.08175 6.71386 9.4769 6.99287C9.87187 6.71367 10.3469 6.56189 10.8337 6.56189C11.3207 6.56189 11.7958 6.71386 12.1908 6.99306C12.5866 6.71386 13.0617 6.56189 13.5485 6.56189C14.0357 6.56189 14.5106 6.71386 14.9055 6.99287C15.3006 6.71367 15.7755 6.56189 16.2625 6.56189C16.7497 6.56189 17.2246 6.71386 17.6195 6.99287C18.0146 6.71367 18.4895 6.56189 18.9765 6.56189C20.2592 6.56189 21.3054 7.59412 21.3278 8.87165C21.3303 8.88524 21.3314 8.89934 21.3314 8.91359C21.3308 9.04567 21.2239 9.15249 21.0919 9.15249ZM3.5472 8.67477H20.8347C20.717 7.75384 19.9283 7.03961 18.976 7.03961C18.5363 7.03961 18.1089 7.19501 17.7726 7.47722C17.6838 7.55166 17.5543 7.55166 17.4654 7.47722C17.1294 7.19501 16.7017 7.03961 16.262 7.03961C15.8222 7.03961 15.3948 7.19501 15.0585 7.47722C14.9698 7.55166 14.8403 7.55166 14.7514 7.47722C14.4154 7.19501 13.9877 7.03961 13.5479 7.03961C13.1085 7.03961 12.6806 7.19501 12.3434 7.47732C12.2548 7.55161 12.1253 7.55147 12.0367 7.47713C11.7003 7.19496 11.2731 7.03956 10.8333 7.03956C10.3935 7.03956 9.96615 7.19496 9.63005 7.47713C9.54128 7.55161 9.41179 7.55161 9.32306 7.47713C8.98668 7.19496 8.55941 7.03956 8.11963 7.03956C7.67995 7.03956 7.25249 7.19496 6.91625 7.47713C6.82748 7.55161 6.69794 7.55161 6.60921 7.47713C6.27283 7.19496 5.84561 7.03956 5.40583 7.03956C4.45354 7.03961 3.66484 7.75384 3.5472 8.67477Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.7327 5.2592C9.60085 5.2592 9.49384 5.15218 9.49384 5.02034V3.65935C9.49384 3.52755 9.60085 3.42053 9.7327 3.42053C9.86454 3.42053 9.97156 3.52755 9.97156 3.65935V5.02034C9.97156 5.15237 9.86459 5.2592 9.7327 5.2592Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.81595 5.2592C4.6841 5.2592 4.57709 5.15218 4.57709 5.02034V3.65935C4.57709 3.52755 4.6841 3.42053 4.81595 3.42053C4.94779 3.42053 5.05476 3.52755 5.05476 3.65935V5.02034C5.05476 5.15237 4.94784 5.2592 4.81595 5.2592Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.50345 3.83867C8.3716 3.83867 8.26459 3.73165 8.26459 3.59981V2.23881C8.26459 2.10697 8.3716 2 8.50345 2C8.63529 2 8.74231 2.10697 8.74231 2.23881V3.59981C8.74231 3.73165 8.63529 3.83867 8.50345 3.83867Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.04495 3.83867C5.91311 3.83867 5.80609 3.73165 5.80609 3.59981V2.23881C5.80609 2.10697 5.91311 2 6.04495 2C6.1768 2 6.28381 2.10697 6.28381 2.23881V3.59981C6.28381 3.73165 6.1768 3.83867 6.04495 3.83867Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.2742 4.82768C7.14236 4.82768 7.03534 4.72066 7.03534 4.58882V3.22787C7.03534 3.09603 7.14236 2.98901 7.2742 2.98901C7.40604 2.98901 7.51306 3.09603 7.51306 3.22787V4.58882C7.51306 4.72071 7.40614 4.82768 7.2742 4.82768Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6493 5.2592C14.5175 5.2592 14.4105 5.15218 14.4105 5.02034V3.65935C14.4105 3.52755 14.5176 3.42053 14.6493 3.42053C14.7811 3.42053 14.8882 3.52755 14.8882 3.65935V5.02034C14.8884 5.15237 14.7812 5.2592 14.6493 5.2592Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.7327 5.2592C9.60085 5.2592 9.49384 5.15218 9.49384 5.02034V3.65935C9.49384 3.52755 9.60085 3.42053 9.7327 3.42053C9.86454 3.42053 9.97156 3.52755 9.97156 3.65935V5.02034C9.97156 5.15237 9.86473 5.2592 9.7327 5.2592Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4201 3.83867C13.2882 3.83867 13.1812 3.73165 13.1812 3.59981V2.23881C13.1812 2.10697 13.2884 2 13.4201 2C13.5518 2 13.6589 2.10697 13.6589 2.23881V3.59981C13.6591 3.73165 13.5519 3.83867 13.4201 3.83867Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9618 3.83867C10.83 3.83867 10.723 3.73165 10.723 3.59981V2.23881C10.723 2.10697 10.83 2 10.9618 2C11.0936 2 11.2006 2.10697 11.2006 2.23881V3.59981C11.2006 3.73165 11.0936 3.83867 10.9618 3.83867Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.191 4.82768C12.0592 4.82768 11.9521 4.72066 11.9521 4.58882V3.22787C11.9521 3.09603 12.0592 2.98901 12.191 2.98901C12.3229 2.98901 12.4299 3.09603 12.4299 3.22787V4.58882C12.4299 4.72071 12.3229 4.82768 12.191 4.82768Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5662 5.2592C19.4344 5.2592 19.3274 5.15218 19.3274 5.02034V3.65935C19.3274 3.52755 19.4345 3.42053 19.5662 3.42053C19.698 3.42053 19.8051 3.52755 19.8051 3.65935V5.02034C19.8051 5.15237 19.6981 5.2592 19.5662 5.2592Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6493 5.2592C14.5175 5.2592 14.4105 5.15218 14.4105 5.02034V3.65935C14.4105 3.52755 14.5176 3.42053 14.6493 3.42053C14.7811 3.42053 14.8882 3.52755 14.8882 3.65935V5.02034C14.8884 5.15237 14.7812 5.2592 14.6493 5.2592Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3371 3.83867C18.2053 3.83867 18.0983 3.73165 18.0983 3.59981V2.23881C18.0983 2.10697 18.2054 2 18.3371 2C18.4688 2 18.576 2.10697 18.576 2.23881V3.59981C18.576 3.73165 18.469 3.83867 18.3371 3.83867Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8786 3.83867C15.7467 3.83867 15.6397 3.73165 15.6397 3.59981V2.23881C15.6397 2.10697 15.7469 2 15.8786 2C16.0103 2 16.1174 2.10697 16.1174 2.23881V3.59981C16.1175 3.73165 16.0104 3.83867 15.8786 3.83867Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.1079 4.82768C16.976 4.82768 16.869 4.72066 16.869 4.58882V3.22787C16.869 3.09603 16.9761 2.98901 17.1079 2.98901C17.2396 2.98901 17.3467 3.09603 17.3467 3.22787V4.58882C17.3467 4.72071 17.2398 4.82768 17.1079 4.82768Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3254 13.3283H16.4479C16.3161 13.3283 16.209 13.2212 16.209 13.0895V8.91354C16.209 8.7817 16.3162 8.67468 16.4479 8.67468H19.3254C19.4573 8.67468 19.5643 8.7817 19.5643 8.91354V13.0893C19.5643 13.2214 19.4573 13.3283 19.3254 13.3283ZM16.6868 12.8505H19.0864V9.15241H16.6868V12.8505Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.1432 21.4521H2.23886C2.10702 21.4521 2 21.3449 2 21.2132C2 21.0815 2.10702 20.9744 2.23886 20.9744H22.1432C22.2751 20.9744 22.3821 21.0815 22.3821 21.2132C22.3821 21.3449 22.2751 21.4521 22.1432 21.4521Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};
